import React from 'react'
import PDIComponent from './PDIComponent'
import PDIComponentV2 from './PDIComponentV2'

export const PDIYapilmayacakA = () => {
    return <PDIComponent title="PDI Yapılmayacak" defaultRadio="Hasar Bildir" showSwitch={false} api="/arac-yapilmayacak" modalArea="PDI Yapılmayacak" minCharacter={8} />
}


export const PDIGirisA = () => {
    return <PDIComponent
        role_name={"pdi_giris_write"}
        title="PDI Giriş" api={"/pdi/giris"} radioItems={["PDI Giriş", "Hasar Bildir"]} defaultRadio="PDI Giriş" showSwitch={false} modalArea="PDI Giriş" minCharacter={8} />
}



export const PDIDonusA = () => {
    return <PDIComponent
        role_name={"pdi_donus_write"}
        title="PDI Dönüş" api={"/pdi/processPDIDataRemoval"} radioItems={["PDI Dönüş", "Hasar Bildir"]} defaultRadio="PDI Dönüş" showSwitch={false} modalArea="PDI Dönüş" minCharacter={8} />
}



export const PDICikisA = () => {
    return <PDIComponent
        role_name={"pdi_cikis_write"}
        depo={false} title="PDI Çıkış" radioItems={["PDI Çıkış", "Hasar Bildir"]} defaultRadio="PDI Çıkış" showSwitch={true} api="/pdi/cikis" modalArea="PDI Çıkış" minCharacter={8} />
}
export const PDICikisA2 = () => {
    return <PDIComponentV2
        role_name={"pdi_cikis_write"}
        depo={false} title="PDI Çıkış" radioItems={["PDI Çıkış", "Hasar Bildir"]} defaultRadio="PDI Çıkış" showSwitch={true} api="/pdi/cikis" modalArea="PDI Çıkış" minCharacter={8} />
}
